import { HttpContextToken } from '@angular/common/http';

// new auth context
export const IS_CALENSO_AUTH_REQUIRED = new HttpContextToken<boolean>(() => false);

// landing pages context
export const LANDING_PAGE_AUTH_REQUIRED = new HttpContextToken<string>(() => '');
